var _rect, _path, _path2, _path3, _path4, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 38,
    height: 38,
    rx: 3,
    fill: "#FFF9EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2268 13.8711C10.2246 13.7213 10.256 13.5701 10.3216 13.4258C10.3873 13.2812 10.4872 13.1434 10.6204 13.0234C10.7538 12.9034 10.9173 12.8042 11.1028 12.7344C11.2421 12.682 11.3908 12.6475 11.5432 12.6328L11.6966 12.625L26.3079 12.625L26.4632 12.6338C26.8206 12.6695 27.145 12.8121 27.3811 13.0254C27.6482 13.2667 27.7772 13.5729 27.7727 13.8711L27.7727 27.0459C27.7749 27.1955 27.7435 27.3461 27.678 27.4902C27.6123 27.6349 27.5124 27.7726 27.3792 27.8926C27.2457 28.0127 27.0824 28.1128 26.8968 28.1826C26.7111 28.2524 26.5089 28.29 26.303 28.292L11.6966 28.292C11.4907 28.29 11.2885 28.2524 11.1028 28.1826C10.9172 28.1128 10.7538 28.0127 10.6204 27.8926C10.4873 27.7726 10.3873 27.6348 10.3216 27.4902C10.2561 27.3461 10.2247 27.1955 10.2268 27.0459L10.2268 13.8711Z",
    stroke: "#330C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6296 9.58325V11.9999",
    stroke: "#330C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3704 9.58325V11.9999",
    stroke: "#330C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60184 16.8333L28.3981 16.8333",
    stroke: "#330C00",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.679,
    y: 12.8101,
    width: 17,
    height: 4,
    fill: "#330C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendly);
export default __webpack_public_path__ + "static/media/icon-calendly.39d7558888ae02bb28712ff3aed3b77d.svg";
export { ForwardRef as ReactComponent };